import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var DEV = process.env.NODE_ENV !== 'production';
var Logger = /*#__PURE__*/function () {
  function Logger(logger) {
    _classCallCheck(this, Logger);
    _defineProperty(this, "logger", void 0);
    this.logger = logger || {
      warn: function warn() {}
    };
  }
  _createClass(Logger, [{
    key: "console",
    value: function console(level, msg, component) {
      this.logger[level](component ? "[".concat(component, "]: ").concat(msg) : msg);
    }
  }, {
    key: "warn",
    value: function warn(condition, msg, component) {
      if (DEV) {
        if (condition) {
          this.console('warn', msg, component);
        }
      }
    }
  }]);
  return Logger;
}();
export { Logger };
export default new Logger(console);
//# sourceMappingURL=logger.mjs.map